import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import FormDrawer from "src/components/Form/FormDrawer";
import { updateExtraServiceGroupSaga } from "src/store/extra-service-group/saga";
import { ExtraServiceGroupDetailDto } from "src/store/extra-service-group/type";
import { getSectors } from "src/store/system/saga";
import { SectorDto } from "src/store/system/type";
import * as Yup from "yup";

const ExtraServiceGroupEditForm = ({
  data,
  onHide,
  open,
  onSuccessClick,
}: {
  data: ExtraServiceGroupDetailDto;
  onSuccessClick: (message: string) => void;
  onHide: () => void;
  open: boolean;
}) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const [sectors, setSectors] = useState<SectorDto[]>([]);
  useEffect(() => {
    open &&
      dispatch(
        getSectors({
          payload: {
            onSuccess: (m, p) => setSectors(p),
            onError: () => {},
          },
        })
      );
  }, [dispatch, open]);
  return (
    <React.Fragment>
      <FormDrawer
        drawerProps={{
          isOpen: open,
          onHide: onHide,
          title: t("ExtraServiceGroup.EditFormTitle").toString(),
        }}
        onHide={onHide}
        loader
        initialValues={{
          Id: data.Id,
          Name: data.Name,
          SectorId: data.SectorId,
          Translates: data.Translates,
        }}
        validationSchema={Yup.object().shape({
          Name: Yup.string().required(t("Validation.Required").toString()),
          SectorId: Yup.string().required(t("Validation.Required").toString()),
          Translates: Yup.array(
            Yup.object({
              Name: Yup.string().required(t("Validation.Required").toString()),
            })
          ),
        })}
        multilanguageinputs={[
          {
            field: "Name",
            label: t("ExtraServiceGroup.Name").toString(),
          },
        ]}
        inputs={[
          {
            field: "SectorId",
            label: t("ExtraServiceGroup.Sector").toString(),
            type: "select",
            lookup: {
              labelKey: "Name",
              valueKey: "Id",
              options: sectors,
            },
          },
        ]}
        onSubmit={(values) => {
          dispatch(
            updateExtraServiceGroupSaga({
              payload: {
                onSuccess: (message, payload) => {
                  onHide();
                  onSuccessClick(message);
                },
                onError: (message) => {
                  toast.error(message, {
                    theme: "colored",
                  });
                },
              },
              id: data.Id,
              body: values,
            })
          );
        }}
      />
    </React.Fragment>
  );
};
export default ExtraServiceGroupEditForm;
